import { ErrorScreen } from '@/pages/ErrorScreen';
import { AuthRoutes } from '@/features/auth/routes';
import { PasswordResetRoutes } from '@/features/password-reset/routes';
import { LogoutIframe } from '@/features/auth/components/LogoutIframe';
import { ArticleDetail } from '@/features/article-detail/routes/ArticleDetail';
import { Navigate } from 'react-router-dom';
import { ForceLoginState } from '@/providers/ForceLoginState';
import { PublicApp } from '@/routes/PublicApp';

export const LOGIN_PATH = '/auth/login';

export const publicRoutes = [
  {
    element: <PublicApp />,
    children: [
      // ログイン状態に関わらずアクセス可能なルート（ForceLoginStateの外側）
      {
        path: '/auth/logout-iframe',
        element: <LogoutIframe />,
      },
      {
        path: '/articles/:code',
        element: <ArticleDetail />,
      },
      {
        element: <ForceLoginState type="guestOnly" />,
        children: [
          {
            path: '/',
            element: <Navigate to={LOGIN_PATH} />,
          },
          {
            path: '/auth/*',
            element: <AuthRoutes />,
          },
          {
            path: '*',
            element: <ErrorScreen opts={{ statusCode: 404 }} />,
          },
        ],
      },
      {
        element: <ForceLoginState type="guestOnly" />,
        children: [
          {
            path: '/password-reset/*',
            element: <PasswordResetRoutes />,
          },
        ],
      },
    ],
  },
];
